import React, { useContext, useEffect, useState } from "react";
import {
  CurrentValue,
  IconLabel,
  ProfileBanner,
  ProfileBannerLeft,
  ProfileBannerRight,
  ProfileContainer,
  ProfileContent,
  ProfileWrapper,
  ProgressBar,
  ProgressTrack,
  RankContainer,
  RankValue,
} from "./styled";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import Porfolio from "./Porfolio";
import History from "./History";
import Referral from "./Refarral";
import RewardsHistory from "./Rewards";
import Launchpad from "./Launchpad";
import ModalOverlay from "../../components/Common/ModalOverlay";
import ModalUpdateProfile from "./ModalUpdateProfile";
import { ContextProviderWrapper } from "../../components/Context";
import { useSelector } from "react-redux";
import {
  selectUserProfile,
  selectUserStats,
} from "../../store/features/profileSlice";
import { shortenAddress } from "../../utils/addressUser";
import { AVAX_API } from "../../services/api/indexV2";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { ButtonCommon } from "../../Layout/styled";
import ModalClaim from "../Leaderboard/ModalClaim";
import { LeaderboardDaily } from "../Avax/Leaderboard/styled";
import TabsSelector from "../Avax/Farm/TabsSelector";
import { useAppKitAccount } from "@reown/appkit/react";
import ModalUpdateBio from "./ModalUpdateBio";
import { convertFixed } from "../../utils/convertNumber";
interface DailyInterface {
  streak: number;
  completed_quest: number;
}
const Profile = () => {
  const { address } = useAppKitAccount();
  const [activeTab, setActiveTab] = useState(1);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openConfirmModalClaim, setOpenConfirmModalClaim] = useState(false);
  const [openModalUpdateBio, setOpenModalUpdateBio] = useState(false);
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;
  const userProfile = useSelector(selectUserProfile);
  const userSocial = useSelector(selectUserProfile);
  const data = useSelector(selectUserStats);
  const [dataPoints, setDataPoints] = useState<any>();
  const [dataCheckin, setDataCheckin] = useState<DailyInterface | null>();
  const { currentChain }: any = useSelector((state: any) => state.pool);
  const [balance, setBalance] = useState<any>();
  const [dataTask, setDataTask] = useState<any>();
  const [totalBalanceWallet, setTotalBalanceWallet] = useState(0);
  let current = data?.point ? Number(data?.point?.toFixed(2)) : 0;
  let min = data?.level?.min_point ? data?.level?.min_point : 0;
  let max = data?.next_level?.min_point ? data?.next_level?.min_point : 0;
  const percentage = ((current - min) / (max - min)) * 100;
  const TabsTitle = [
    {
      title: "Porfolio",
      value: 1,
    },
    {
      title: "Transaction History",
      value: 2,
    },
    {
      title: "Referral",
      value: 3,
    },
    {
      title: "Rewards History",
      value: 4,
    },
    {
      title: "Launchpad Registration",
      value: 5,
    },
  ];

  // get data points
  const fetchDataPoints = async () => {
    try {
      const params = "S1";
      const res = await AVAX_API.getPoints(params);
      setDataPoints(res?.data);
    } catch (err) {
      console.error("Failed to fetch tx:", err);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("TOKEN")) {
      fetchDataPoints();
    }
  }, [localStorage.getItem("TOKEN")]);

  const handleChangeTabs = () => {
    switch (activeTab) {
      case 1:
        return (
          <Porfolio
            balance={balance}
            currentChain={currentChain}
            setTotalBalanceWallet={setTotalBalanceWallet}
          />
        );
      case 2:
        return <History />;
      case 3:
        return <Referral userProfile={userProfile.user} />;
      case 4:
        return <RewardsHistory dataPoints={dataPoints} />;
      default:
        return <Launchpad />;
    }
  };

  const listStats = [
    {
      icn: "/assets/images/profile/icn_rank_02.svg",
      title: "Ranking",
      number: data?.ranking ? data?.ranking : 0,
    },
    {
      title: "Trade volume",
      number: data.trade_volume ? `$${convertFixed(data?.trade_volume)}` : 0,
    },
    {
      title: "Streak",
      number: dataCheckin ? dataCheckin?.streak : 0,
    },
    {
      title: "Completed Quests",
      number: dataCheckin ? dataCheckin?.completed_quest : 0,
    },
  ];

  const handleLoginDiscord = () => {
    const clientId = "1375304392164511825";
    const redirectUri = "https://dev-kibble-avax.netlify.app";
    const url = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=identify`;

    window.location.href = url;
  };

  const handleLoginTwitter = async () => {
    try {
      const { data } = await AVAX_API.handleLoginTwitter();
      if (data.oauth_token) {
        window.location.href = `https://api.twitter.com/oauth/authorize?oauth_token=${data.oauth_token}`;
      } else {
        alert("Unable to get Twitter oauth_token");
      }
    } catch (err) {
      console.error("Twitter login init failed", err);
    }
  };

  const handleLoginTelegram = () => {
    const telegramButton = document.querySelector(
      "#telegram-widget button"
    ) as HTMLElement | null;

    if (telegramButton) {
      telegramButton.click();
    } else {
      console.warn("Telegram widget button not found");
    }
  };

  const shareOptions = [
    {
      name: "Telegram",
      icon: "/assets/images/profile/icn_social_01.svg",
      onClick: handleLoginTelegram,
    },
    {
      name: "Twitter",
      icon: "/assets/images/profile/icn_social_02.svg",
      onClick: handleLoginTwitter,
    },
    {
      name: "Discord",
      icon: "/assets/images/profile/icn_social_03.svg",
      onClick: handleLoginDiscord,
    },
  ];

  const connectedProviders =
    userSocial?.userSocial?.map((item: any) =>
      item.provider_name.toLowerCase()
    ) || [];

  //get data checkin info
  const getDataCheckin = async () => {
    const { data } = await AVAX_API.getDataCheckin();
    setDataCheckin(data);
  };
  useEffect(() => {
    getDataCheckin();
  }, []);

  //get balance
  const chainRouter = currentChain;
  const handleChangeChainName = () => {
    switch (chainRouter) {
      case "Avalanche":
        return "AVAX_CCHAIN";
      case "Solana":
        return "SOLANA";
      case "Toncoin":
        return "TON";
    }
  };
  useEffect(() => {
    const getBalance = async () => {
      const params: any = [`${handleChangeChainName()}.${address}`];
      let convertParams = "";
      params.forEach((element: string) => {
        convertParams += `address=${element}&`;
      });
      const res = await AVAX_API.getBalanceTokens(convertParams);
      setBalance(res?.data);
    };
    if (address) {
      getBalance();
    }
  }, [address]);

  //daily task to day
  const getTaskToday = async () => {
    const res = await AVAX_API.getTaskToday();
    setDataTask(res?.data);
  };
  useEffect(() => {
    getTaskToday();
  }, []);

  return (
    <>
      <ProfileContainer>
        <ProfileWrapper>
          <LeaderboardDaily className={theme}>
            <div className="daily-left">
              <img
                src="/assets/images/leaderboard/icn_noti.svg"
                width={44}
                height={44}
                loading="lazy"
                alt="Noti"
              />
              <p>
                {dataTask?.task?.name ? dataTask?.task?.name : "No taks to day"}
              </p>
            </div>
            <div className="daily-right">
              <ButtonCommon
                background="#E94A4A"
                onClick={() => setOpenConfirmModalClaim(true)}
                disabled={dataTask?.is_done && true}
              >
                {dataTask?.is_done ? "Completed" : "Claim"}
              </ButtonCommon>
            </div>
          </LeaderboardDaily>
          <h1 className={`title-profile ${theme}`}>Profile</h1>
          <ProfileBanner className={theme}>
            <ProfileBannerLeft className={theme}>
              <div className="banner-info">
                <div className="banner-image">
                  <img
                    src={
                      userProfile?.user?.avatar
                        ? userProfile?.user?.avatar
                        : "/assets/images/profile/profile_img_01.png"
                    }
                    width={100}
                    height={100}
                    loading="lazy"
                    alt="icon"
                    className="image-user"
                  />
                  <div className="rank">
                    <img
                      src="/assets/images/profile/icn_rank.svg"
                      width={27}
                      height={32}
                      loading="lazy"
                      alt="Rank"
                    />
                  </div>
                  <div
                    className="button-edit"
                    onClick={() => setOpenConfirmModal(true)}
                  >
                    Edit
                  </div>
                </div>
                <div className="banner-detail">
                  <h2 className="name">
                    {userProfile?.user?.name
                      ? userProfile?.user?.name
                      : "No name"}
                  </h2>
                  <p className="address">
                    {userProfile?.user?.address
                      ? shortenAddress(userProfile?.user?.address)
                      : "--"}
                    <img
                      src="/assets/images/profile/icn_copy.svg"
                      width={16}
                      height={16}
                      loading="lazy"
                      alt="Copy"
                      className="copy trans"
                    />
                  </p>
                  <p className="bio">
                    <span>
                      {userProfile?.user?.bio
                        ? userProfile?.user?.bio
                        : "No bio"}
                    </span>
                    <img
                      src="/assets/images/profile/icn_edit.svg"
                      width={16}
                      height={16}
                      loading="lazy"
                      alt="Edit"
                      className="trans"
                      onClick={() => setOpenModalUpdateBio(true)}
                    />
                  </p>
                </div>
              </div>
              <div className="banner-stats">
                <ul className="list-stats">
                  {listStats.map((item, index) => (
                    <li key={index}>
                      <h3 className="name-stats">
                        {item.icn && (
                          <img
                            src="/assets/images/profile/icn_rank_02.svg"
                            width={12}
                            height={12}
                            loading="lazy"
                            alt="Rank"
                          />
                        )}
                        {item.title}
                      </h3>
                      <p className="number-stats">{item.number}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="banner-referral">
                <div className="referral-wrapper">
                  <span className="label">Referral Link</span>
                  <p className="ref-code">
                    {`https://app.kibble.exchange/profile?${userProfile?.user?.referralCode}`}
                  </p>
                  <button className="copy-button">
                    <CopyToClipboard
                      text={`https://app.kibble.exchange/profile?${userProfile?.user?.referralCode}`}
                      // text={`http://localhost:3000/swap/avax?from=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&to=0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e&ref=${userProfile?.user?.referralCode}`}
                      onCopy={() => {
                        toast.success("Copied !!");
                      }}
                    >
                      <div className={`copy-inner ${theme}`}>
                        <img
                          src="/assets/images/profile/icn_copy.svg"
                          width={16}
                          height={16}
                          loading="lazy"
                          alt="Copy"
                          className="trans"
                        />
                      </div>
                    </CopyToClipboard>
                  </button>
                </div>
                <div className="button-group">
                  {shareOptions.map((option: any) => {
                    const isActive = connectedProviders.includes(
                      option.name.toLowerCase()
                    );
                    return (
                      <div
                        className={`icon-button ${isActive ? "active" : ""}`}
                        key={option.name}
                      >
                        {/* <Link to={option.url} className="trans"> */}
                        <div
                          onClick={option.onClick}
                          className={`item-button trans`}
                        >
                          <img
                            src={option.icon}
                            width={20}
                            height={20}
                            loading="lazy"
                            alt={option.provider_name}
                          />
                        </div>

                        {/* </Link> */}
                      </div>
                    );
                  })}
                </div>
              </div>
            </ProfileBannerLeft>
            <ProfileBannerRight className={theme}>
              <div className="block-point">
                <div className="total-point">
                  {/* <img
                    src="/assets/images/profile/icn_kibble.png"
                    width={40}
                    height={40}
                    loading="lazy"
                    alt="Kibble"
                  /> */}
                  <p className="price">
                    ${totalBalanceWallet ? totalBalanceWallet.toFixed(2) : 0}
                  </p>
                </div>
                <p className="point">
                  Total Point: {data?.point ? data?.point?.toFixed(2) : 0}
                </p>
              </div>
              <RankContainer>
                <div className="left">
                  <IconLabel>
                    <img
                      src={
                        data?.level?.logo_url
                          ? data?.level?.logo_url
                          : `/assets/images/profile/icn_rank_04.svg`
                      }
                      width={19}
                      height={23}
                      loading="lazy"
                      alt="start-rank"
                    />
                  </IconLabel>
                  <RankValue className={theme}>{min}</RankValue>
                </div>

                <ProgressTrack className={theme}>
                  <ProgressBar
                    className={theme}
                    style={{ width: `${percentage}%` }}
                  />
                  <CurrentValue style={{ left: `${percentage}%` }}>
                    {/* <Tooltip placement="topLeft" title={current}>
                    {current}
                  </Tooltip> */}
                    <Tooltip
                      placement="top"
                      title={current}
                      arrow={true}
                      defaultOpen={true}
                      trigger={"click"}
                      open={true}
                      getPopupContainer={(triggerNode: HTMLElement) =>
                        triggerNode
                      }
                    >
                      <div className="circle">
                        <img
                          src={
                            theme === "light"
                              ? "/assets/images/profile/icn_circle_light.svg"
                              : "/assets/images/profile/icn_circle.svg"
                          }
                          width={26}
                          height={26}
                          loading="lazy"
                          alt="Circel"
                        />
                      </div>
                    </Tooltip>
                  </CurrentValue>
                </ProgressTrack>

                <div className="right">
                  <IconLabel>
                    <img
                      src={
                        data?.next_level?.logo_url
                          ? data?.next_level?.logo_url
                          : `/assets/images/profile/icn_rank_03.svg`
                      }
                      width={27}
                      height={27}
                      loading="lazy"
                      alt="end-rank"
                    />
                  </IconLabel>
                  <RankValue className={theme}>{max}</RankValue>
                </div>
              </RankContainer>
            </ProfileBannerRight>
          </ProfileBanner>
          <ProfileContent>
            <TabsSelector
              data={TabsTitle}
              callBack={(data: any) => {
                setActiveTab(data?.value);
              }}
              active={activeTab}
            />
            <div
              style={{
                marginTop: "24px",
              }}
            >
              {handleChangeTabs()}
            </div>
          </ProfileContent>
        </ProfileWrapper>
      </ProfileContainer>
      <ModalOverlay
        component={
          <ModalUpdateProfile setOpenConfirmModal={setOpenConfirmModal} />
        }
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        title={""}
        width="500px"
        top={isMobile ? "40%" : ""}
      />
      <ModalOverlay
        component={<ModalClaim dataTask={dataTask} />}
        open={openConfirmModalClaim}
        setOpen={setOpenConfirmModalClaim}
        title={"EARN POINTS"}
        width="500px"
        top={isMobile ? "40%" : ""}
      />
      <ModalOverlay
        component={
          <ModalUpdateBio
            userProfile={userProfile}
            setOpenModalUpdateBio={setOpenModalUpdateBio}
          />
        }
        open={openModalUpdateBio}
        setOpen={setOpenModalUpdateBio}
        title={"UPDATE BIO"}
        width="500px"
        top={isMobile ? "40%" : ""}
      />
    </>
  );
};

export default Profile;
